import { render, staticRenderFns } from "./ReceptionCounterModal.vue?vue&type=template&id=c38cd4c4&scoped=true"
import script from "./ReceptionCounterModal.vue?vue&type=script&lang=js"
export * from "./ReceptionCounterModal.vue?vue&type=script&lang=js"
import style0 from "./ReceptionCounterModal.vue?vue&type=style&index=0&id=c38cd4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38cd4c4",
  null
  
)

export default component.exports